import {Form, Input} from 'antd';
import {FormListFieldData} from 'antd/es/form/FormList';
import React from 'react';


import styles from './group-company-org-info-item.module.less';

interface IForeignParentInfoItemProps {
    foreignParents: FormListFieldData[];
}

export const ForeignParentInfoItem = (
    ({foreignParents}: IForeignParentInfoItemProps) => (
        <>
            {foreignParents.map((foreignParent) => (
                <section
                    className={styles['dependent-part-list__parents-row']}
                    key={foreignParent.name}
                >
                    <div className="d-flex gap-3 align-items-end">
                        <Form.Item
                            label="Регистрационный номер иностранной материнской компании в стране регистрации (инкорпорации)"
                            name={[foreignParent.name, 'regNumber']}
                            className={styles['dependent-part-list__parents-row--half-width']}
                        >
                            <Input disabled/>
                        </Form.Item>
                        <Form.Item
                            label="Код страны регистрации иностранной материнской компании"
                            name={[foreignParent.name, 'countryCode']}
                            className={styles['dependent-part-list__parents-row--half-width']}
                        >
                            <Input disabled/>
                        </Form.Item>
                        <Form.Item
                            label="Наименование иностранной материнской компании группы компаний (холдинга)"
                            name={[foreignParent.name, 'name']}
                            className={styles['dependent-part-list__parents-row--half-width']}
                        >
                            <Input disabled/>
                        </Form.Item>
                    </div>
                </section>
            ))}
        </>
    )
);
